/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_8_P1Inputs */

const en_terms_section_8_p1 = /** @type {(inputs: Terms_Section_8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This website and its content are provided as they are and as they happen to be available, without warranties of any kind, express or implied.`)
};

const lv_terms_section_8_p1 = /** @type {(inputs: Terms_Section_8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šī tīmekļvietne un tās saturs tiek sniegti tādi, kādi tie ir un kādi tie ir pieejami, bez jebkāda veida tiešām vai netiešām garantijām.`)
};

/**
* | output |
* | --- |
* | "This website and its content are provided as they are and as they happen to be available, without warranties of any kind, express or implied." |
*
* @param {Terms_Section_8_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_8_p1 = /** @type {((inputs?: Terms_Section_8_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_8_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_8_p1(inputs)
	return en_terms_section_8_p1(inputs)
});